<template>
  <div class="trend-control noselect" v-if="getTrendDateRange[0] && this.sensors">
    <div class="main-wrap over-info">
      <!-- Modal Info Selezione Deck -->
      <ModalCalendar
        v-if="showCalendar && getTrendDateRange[0] && getTrendDateRange[1]"
        :datarange="[getTrendDateRange[0], getTrendDateRange[1]]"
        @close="showCalendar = false"
        @update="updateDate"
        @range-selected="rangeSelected"
        :maxDate="isLambro ? new Date('2021-04-23') : new Date()"
        class="ciao"
        id="info-deck"
      />
      <!-- FIRST LINE -->
      <h2 class="first-block">{{ $t("title.trendAndStats") }}</h2>
      <div class="vert-divider second-block"></div>
      <div @click="calendarHandler" class="second-block first-row info-group info-btn">
        <p class="info-btn">{{ $t("message.dateRange") }}:</p>
        <h2 class="info-btn">{{ this.formattedDate[0] + " - " + this.formattedDate[1] }}</h2>
        <i class="info-btn" v-bind:class="[showCalendar ? 'up' : 'down']"></i>
      </div>
      <div class="horiz-divider"></div>
      <h4 class="first-block">{{ $t("message.multiDeckSelect") }}</h4>
      <div class="second-block info-group">
        <p>{{ $t("message.selectedDevices") }}:</p>
        <h4>{{ this.getCheckedSensors.length }}/{{ this.deckList.length }}</h4>
      </div>
      <button class="button" @click="selectAllSensors">
        {{ this.getCheckedSensors.length == this.deckList.length ? $t("message.deselectAll") : $t("message.selectAll") }}
      </button>
    </div>

    <!-- SENSOR LIST -->
    <div>
      <SensorList :sensors="this.deckList" :nSpans="this.nSpans" :selectedDefault="this.getCheckedSensors" v-if="this.getCheckedSensors" @sensors-selected="this.filterBySensor" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import SensorList from "../../ui/SensorList.vue";
import ModalCalendar from "../../ui/ModalCalendar.vue";

export default {
  name: "trend-control",
  components: {
    SensorList,
    ModalCalendar,
  },
  data() {
    return {
      campate: 3,
      selected: this.sensors,
      showCalendar: false,
      actualDateRange: [],
    };
  },
  props: {
    sensors: Array,
    nSpans: Number,
  },
  methods: {
    ...mapActions({
      setDateRange: "trend/setDateRange",
      fetchTrend: "trend/fetchTrend",
      setSensorsPool: "trend/setSensorsPool",
      filterBySensor: "trend/filterBySensor",
      fetchTrendAPI: "trend/fetchTrendAPI",
    }),
    updateDate: function () {
      this.setDateRange(this.actualDateRange);
    },
    rangeSelected: function (dateRange) {
      this.actualDateRange = dateRange;
    },
    formatDate: function (date) {
      let day = date.getDate();
      let year = date.getFullYear();
      let month = date.toLocaleString("default", { month: "short" });
      return day + " " + month + " " + year;
    },
    selectAllSensors: function () {
      // Deseleziona tutti
      if (!(this.getCheckedSensors.length == this.deckList.length)) {
        // Seleziona tutti
        if (this.getCheckedSensors.length != this.deckList.length) {
          this.filterBySensor(this.deckList);
        }
      } else {
        this.filterBySensor([]);
      }
    },
    calendarHandler: function () {
      this.showCalendar = !this.showCalendar;
    },
  },
  computed: {
    ...mapGetters({
      getTrendDateRange: "trend/getDateRange",
      getCheckedSensors: "trend/getCheckedSensors",
      getSensors: "structure/getSensors",
    }),
    isLambro() {
      return this.getSensors ? this.getSensors.some((sn) => sn.eui === "C0EE400001015144") : false;
    },
    formattedDate: function () {
      let firstDate = this.formatDate(this.getTrendDateRange[0]);
      let lastDate = this.formatDate(this.getTrendDateRange[1]);
      return [firstDate, lastDate];
    },
    deckList: function () {
      return this.sensors.filter((sensor) => sensor.type === "deck");
    },
  },
  watch: {
    getTrendDateRange: {
      handler: async function (newVal, oldVal) {
        if (oldVal[0] && oldVal[1] && (newVal[0].getTime() != oldVal[0].getTime() || newVal[1].getTime() != oldVal[1].getTime())) {
          if (!this.firstExec) {
            // Init and Sensor already ok
            this.loaded = false;
            await this.fetchTrendAPI();
            this.loaded = true;
          }
          this.firstExec = false;
        }
      },
      deep: true,
    },
    sensors: {
      handler: async function () {
        await this.setSensorsPool(this.deckList);
        await this.fetchTrendAPI();
      },
      deep: true,
    },
  },
  async mounted() {
    await this.setDateRange([
      // 240 Hours
      this.isLambro ? (new Date(new Date("2021-04-23").getTime() - 7 * 24 * 60 * 60 * 1000)):
      new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
      this.isLambro ? new Date("2021-04-23") : new Date(),
    ]);
    this.actualDateRange = [this.getTrendDateRange[0], this.getTrendDateRange[1]];
    await this.setSensorsPool(this.deckList);
    await this.fetchTrendAPI();
  },
};
</script>
<style scoped>
.ciao {
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  border-color: rgb(91, 96, 118);
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

#info-deck {
  position: absolute;
  top: 43px;
  max-width: 770px;
  margin-left: 319px;
  background-color: rgb(45, 48, 65);
}

.trend-control {
  border: solid 3px white;
  position: relative;
  min-width: 1100px;
  width: 92%;
  background-color: rgb(45, 48, 65);
  margin-left: 4%;
  margin-right: 4%;
  padding-bottom: 10px;
  padding-top: 20px;
  margin-top: 50px;
  border-radius: 10px;
  -webkit-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 9px 37px -20px rgba(0, 0, 0, 0.75);
}

/* Tra 600 e 1499 */
@media all and (max-width: 1499px) and (min-width: 300px) {
  .trend-control {
    width: 96%;
    margin-left: 2%;
    margin-right: 2%;
  }
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 12x;
  background-color: rgba(32, 34, 47, 1);
}

::-webkit-scrollbar {
  height: 14px;
  padding-top: 5px;
  background-color: rgba(32, 34, 47, 1);
}

::-webkit-scrollbar-thumb {
  border-radius: 12px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(80, 84, 105, 1);
}

.info-group {
  display: flex;
  align-items: baseline;
}
h4 {
  font-size: 0.8em;
  color: white;
  margin: 0;
}
h2 {
  font-size: 1em;
  color: white;
  margin: 0;
}
h1 {
  font-size: 1.5em;
  font-weight: 400;
  color: white;
  margin: 0;
}

p {
  margin: 0;

  font-size: 0.8em;
}

.info-group > p {
  margin-right: 5px;
}

.over-info {
  cursor: default;
  text-align: left;
  position: relative;
  display: grid;
  grid-auto-rows: min-content;
  grid-auto-columns: max-content;
}

#help-tip {
  width: 500px;
  top: 15px;
}
.first-block {
  grid-column: 1;
}
.second-block {
  grid-column: 2;
  /*   padding-left: 200px;
 */
}
.first-row {
  grid-row: 1;
}

.second-row {
  grid-row: 5;
}
.third-block {
  grid-column: 3;
}
.horiz-divider {
  height: 2px;
  background-color: rgba(80, 84, 105, 1);
  margin-top: 25px;
  margin-bottom: 10px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  grid-column-start: 1;
  grid-column-end: 4;
}

.vert-divider {
  grid-row: 1;
  width: 2px;
  background-color: rgba(80, 84, 105, 1);
  position: relative;
  right: 10%;
}

.main-wrap {
  display: grid;
  margin-left: 60px;
  margin-right: 60px;
  grid-template-columns: 35% 55% 10%;
}
#infoi {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
#infoi {
  z-index: 9999999999;
  background-color: black;
  opacity: 0.7;
  border-radius: 10px;
}

.button {
  display: inline-block;
  width: 240px;
  font-size: 1em;
  font-weight: 600;
  text-align: center;
  text-decoration: none;
  outline: none;
  color: #fff;
  background-color: rgb(80, 84, 105);
  border: solid 3px white;
  border-radius: 10px;
  transition: transform 0.1s linear;
  justify-self: end;
}

.button:hover {
  transition: transform 0.1s linear;
  -ms-transform: scale(1.1); /* IE 9 */
  -webkit-transform: scale(1.1); /* Safari 3-8 */
  transform: scale(1.1);
}

.button:active {
  background-color: rgb(47, 112, 177);
  transform: translateY(1px);
}

i {
  border: solid white;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 5px;
  position: relative;
  margin-bottom: auto;
  margin-top: auto;
  margin-left: 10px;
  bottom: 2px;
  transition: transform 0.3s cubic-bezier(0.42, 0, 0.1, 0.96);
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
</style>
